import React from 'react';
import { Box, Switch, FormControlLabel, Typography } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import type { ExportType } from '../types';

interface ExportOptionsProps {
  showEditLevelTags: boolean;
  setShowEditLevelTags: (value: boolean) => void;
  showAccreditationTags: boolean;
  setShowAccreditationTags: (value: boolean) => void;
  exportType: ExportType;
  hasAwbSubscription: boolean;
}

export const ExportOptions: React.FC<ExportOptionsProps> = ({
  showEditLevelTags,
  setShowEditLevelTags,
  showAccreditationTags,
  setShowAccreditationTags,
  exportType,
  hasAwbSubscription,
}) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: 2,
        p: 2,
      }}
    >
      {exportType !== 'tableOfContents' && (
        <FormControlLabel
          control={
            <Switch
              checked={showEditLevelTags}
              onChange={(e) => setShowEditLevelTags(e.target.checked)}
            />
          }
          label={<Typography variant='body2'>{t('draftManuals.export.showEditLevelTags')}</Typography>}
        />
      )}

      {/* // PLAT-2621: This toggle should stay behind the AWB feature flag even after the "Export Draft Manuals" is removed */}
      {hasAwbSubscription && exportType !== 'tableOfContents' && (
        <FormControlLabel
          control={
            <Switch
              checked={showAccreditationTags}
              onChange={(e) => setShowAccreditationTags(e.target.checked)}
            />
          }
          label={<Typography variant='body2'>{t('draftManuals.export.showAccreditationTags')}</Typography>}
        />
      )}
    </Box>
  );
};
